module.exports = __webpack_public_path__ + "static/media/CUDI DARBAS.f3e6e6e5.png";